import React from "react";
import { useHistory } from 'react-router-dom';
import { pushAppRoute } from "../../data/domain/route-manager";
import { useCurrentAppRoute } from "../../hooks/app-route-hooks";
import { AppRoute } from "../../routes";
import { ContentContainer } from "../ContentContainer";
import { DataProviderCache } from "../../data/DataProviders/DataProviderCache";
import { DeviceCountProvider } from "../../data/DataProviders/DeviceCountProvider";
import { GenericToolbar } from "../GenericToolbar";
import { SiteProfileData } from "./SiteProfileData";
import { SiteProfile } from "../../types";
 
export const SiteProfilePage: React.FC<{ testId: string; appRoute: AppRoute ;data: SiteProfile}> = (props) => {
    const history = useHistory();
    const currentAppRoute = useCurrentAppRoute();
    return (
        <>
            <GenericToolbar
                title={props.data.name}
                subtitle="Site Profile"
                showBackButton
                backButtonOnClick={(): void => {
                    pushAppRoute(history, props.appRoute);
                }}
            />
            {'siteId' in currentAppRoute && (
                <ContentContainer>
                    <DataProviderCache for={'device-count'}>
                        <DeviceCountProvider siteId={currentAppRoute.siteId}>
                            <SiteProfileData appRoute={props.appRoute} data={ props.data}/>
                        </DeviceCountProvider>
                    </DataProviderCache>
                </ContentContainer>
            )}
        </>)
}